// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DonutChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DonutChartIcon" ref={forwardedRef} {...props}>
      <path d="M9.997 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1.5a6.5 6.5 0 0 1-2.606-.543l1.263-2.189a4 4 0 0 0 5.274-3.018h2.526a6.5 6.5 0 0 1-6.457 5.75m-3.901-1.3A6.501 6.501 0 0 1 9.25 3.543V6.07a4.001 4.001 0 0 0-1.888 6.938zm7.833-5.95a4 4 0 0 0-3.179-3.18V3.543a6.5 6.5 0 0 1 5.704 5.707zm-3.93 3.25a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DonutChartIcon = /* @__PURE__ */ Object.assign(
  DonutChartIconComponent,
  { displayName: 'DonutChartIcon' },
);
